"use client";

import { useEffect } from "react";
import { afterInitialPaint } from "@/lib/after-initial-paint";

export function ProgressiveFonts() {
  useEffect(() => {
    afterInitialPaint(() => {
      const root = document.documentElement;
      const styles = getComputedStyle(root);
      const families = ["--font-inter-latin", "--font-jetbrains-latin"]
        .map((name) => styles.getPropertyValue(name).trim().split(",")[0]);
      void Promise.all(families.map((family) => document.fonts.load(`400 16px ${family}`)))
        .finally(() => root.removeAttribute("data-fonts-pending"))
        .catch(() => {});
    });
  }, []);
  return null;
}
